<script>
  // Перенос Empty из parts.tsx — пустое состояние раздела.
  import Ico from './ico.svelte';
  import { t } from '../i18n.js';

  export let icon = 'info';
  export let text = '';
</script>

<div class="mn-empty">
  <Ico n={icon} s={30} class="ec" />
  <div class="et">{text || t('m.empty')}</div>
</div>
